import React, { useEffect, useState } from "react";
import _ from "lodash";
import AppConstants from "../../constants/AppConstants";
import UIActions from "../../actions/UIActions";
import useDesignImport from "../../hooks/query/useDesignImport";
import Modal from "../base/Modal";
import ImportMainView from "./ImportMainView.jsx";
import SubviewProcessing from "../SubviewProcessing.jsx";
import ImportPreviewView from "./ImportPreviewView.jsx";
import SubviewError from "../SubviewError.jsx";
import ImportCompleteView from "./ImportCompleteView.jsx";
import APIError from "../../service/APIError";
import ErrorUtils from "../../utils/ErrorUtils";

const DesignImportModal = (props) => {
  const [addDesignState, setAddDesignState] = useState(AppConstants.IMPORT_DESIGN_INITIAL);
  const {
    isLoading,
    isSuccess,
    isError,
    error: designImportQueryError,
    fetchStatus,
    data,
    getDesign,
    clearDesign,
  } = useDesignImport();
  useEffect(() => clearDesign, []);

  const _close = () => UIActions.modalClose(AppConstants.MODAL_DESIGN_IMPORT);

  let isPreview = false;
  let currentView = null;
  if (addDesignState === AppConstants.IMPORT_DESIGN_COMPLETED) {
    currentView = <ImportCompleteView designExport={data.designExport} close={_close} />;
  } else if (isLoading || addDesignState === AppConstants.IMPORT_DESIGN_LOADING) {
    currentView = <SubviewProcessing message="Adding Design To Your Library" />;
  } else if (isError || addDesignState !== AppConstants.IMPORT_DESIGN_INITIAL) {
    const err = designImportQueryError || addDesignState;
    if (!APIError.handle(err)) {
      const formattedError = ErrorUtils.getFormattedError(err);
      currentView = <SubviewError error={formattedError} onClose={_close} />;
    }
  } else if (isSuccess && data.designExport !== null) {
    isPreview = true;
    currentView = (
      <ImportPreviewView
        designExport={data.designExport}
        setAddDesignState={setAddDesignState}
        addDesignState={addDesignState}
      />
    );
  } else if (fetchStatus === 'idle') {
    currentView = (
      <ImportMainView
        close={_close}
        getDesign={getDesign}
        processError={isSuccess && !data.designExport}
      />
    );
  }

  const panelStyle = isPreview ? { height: "100%", width: "100%" } : { height: 200 };
  const modalProps = _.pick(props, Modal.BASIC_PROPS);

  return (
    <Modal {...modalProps} style={isPreview ? { padding: 0 } : null} backdrop="static">
      <Modal.Dialog size={isPreview ? "large" : null}>
        <Modal.Dialog.Header closeButton>
          <Modal.Dialog.Title>Add A Design</Modal.Dialog.Title>
        </Modal.Dialog.Header>
        <Modal.Dialog.Body style={{ height: "100%" }}>
          <div style={panelStyle}>{currentView}</div>
        </Modal.Dialog.Body>
      </Modal.Dialog>
    </Modal>
  );
};

export default DesignImportModal;
